import api from './api';

export const register = (data) => api.post('/api/logista/register', data);
export const getMe = () => api.get('/api/logista/me');

export const getLoja = () => api.get('/api/logista/loja');
export const updateLoja = (data) => api.put('/api/logista/loja', data);
export const uploadLogo = (file) => {
  const fd = new FormData();
  fd.append('logo', file);
  return api.post('/api/logista/loja/logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const uploadCover = (file) => {
  const fd = new FormData();
  fd.append('cover', file);
  return api.post('/api/logista/loja/cover', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const getOfertas = () => api.get('/api/logista/ofertas');
export const createOferta = (data) => api.post('/api/logista/ofertas', data);
export const updateOferta = (id, data) => api.put(`/api/logista/ofertas/${id}`, data);
export const deleteOferta = (id) => api.delete(`/api/logista/ofertas/${id}`);

export const getResgates = (params) => api.get('/api/logista/resgates', { params });
export const validarResgate = (qrCode) => api.post('/api/logista/resgates/validar', { qrCode });

export const getAnalytics = () => api.get('/api/logista/analytics');

export const getSubscription = () => api.get('/api/logista/subscription');
